<app-page-content>
<app-doenkids-menu-bar menuBar [loading]="listLoading$ | async">
  <div left>
    <app-user-search [query]="searchQuery" (searched)="doSearch($event)"></app-user-search>
  </div>
</app-doenkids-menu-bar>
<div content>
  <mat-toolbar class="doenkids-toolbar">
  @if (!(searchInAllUsers$ | async)) {
    <h2>
      {{ 'user_list.heading.organization_users' | translate:{ organizationUnitName: currentOUName$ | async } }}
    </h2>
  }
  @if ((searchInAllUsers$ | async)) {
    <h2>{{ 'user_list.heading.all_users' | translate }}</h2>
  }
  <span class="spacer"></span>
  <div class="flex-row gap-4 justify-around items-center">
    <mat-slide-toggle color="primary" (change)="toggleInactiveUsers($event)" [checked]="includeInActiveUsers$ | async">
      {{ 'user_list.active_users_only' | translate }}
    </mat-slide-toggle>
    <mat-slide-toggle color="primary" (change)="toggleSearchAllUsers($event)" [checked]="searchInAllUsers$ | async">
      {{ 'user_list.search_in_organizations' | translate }}
    </mat-slide-toggle>
    @if ((isAdmin$ | async) || (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)) {
      <button
        mat-button
        (click)="downloadUserList()"
        [matTooltip]="'user_list.download.tooltip' | translate"
        >
        <mat-icon svgIcon="excel"></mat-icon>
      </button>
    }
    @if ((isAdmin$ | async)) {
      <button
        mat-button
        (click)="deactivateAllUsersOfOrganization()"
        [matTooltip]="'user_list.deactivate-users.tooltip' | translate: { organizationName: currentOUName$ | async }"
        class="deactivate-users-button"
        >
        <mat-icon>delete</mat-icon>
      </button>
    }
  </div>
</mat-toolbar>

<app-sortable-list
  class="not-selectable"
  (reload)="getList($event)"
  [fields]="fields$ | async"
  [list$]="list$ | async"
  [metadata]="metaData | async"
  [defaultLimit]="15"
  >
  <ng-container *appSortableListFields="let list">
    @for (user of usersList | paginate: ( paginationConfig$ | async); track user) {
      <tr (click)="goToUserDetails(user)"
        >
        <td>
          <div class="cell-wrapper">{{user.email}}</div>
        </td>
        @if ((isAdmin$ | async)) {
          <td>
            <div class="cell-wrapper">
              {{ user.auth0_status === 'UNKNOWN' ? ('generic.unknown' | translate) : ''}}
              {{ user.auth0_status === 'EMAIL_MISMATCH'
              ? ('user_list.auth0_email.label' | translate) + user.auth0_email
              : '' }}
              {{ user.auth0_status === 'OK' ? ('generic.ok' | translate) : ''}}
            </div>
          </td>
        }
        @if ((isAdmin$ | async)) {
          <td>
            <div class="cell-wrapper">{{ user.active ? ('generic.yes' | translate) : ('generic.no' | translate) }}</div>
          </td>
        }
        @if ((isAdmin$ | async)) {
          <td>
            <div class="cell-wrapper">{{user.user_role}}</div>
          </td>
        }
        <td class="d-none d-sm-table-cell">
          <div class="cell-wrapper">{{ user.last_seen | i18n_date: 'dd-MM-yyyy HH:mm' | async }}</div>
        </td>
        <td class="d-none d-md-table-cell">
          <div class="cell-wrapper">{{ user.auth0_login_count }}</div>
        </td>
        <td class="d-none d-md-table-cell">
          <div class="cell-wrapper">{{ user.created_at | i18n_date: 'dd-MM-yyyy HH:mm' | async }}</div>
        </td>
        <td class="d-none d-md-table-cell">
          <div class="cell-wrapper">{{user.organization_unit }}</div>
        </td>
        <td class="d-none d-md-table-cell">
          <div class="cell-wrapper">{{ getUserLinkedOUString(user) }}</div>
        </td>
        <td class="action-col">
          @if (!(isAdmin$ | async) && (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)) {
            <button
              mat-button
              [matTooltip]="'user_list.actions.password_reset' | translate"
              [matTooltipPosition]="'above'"
              (click)="$event.stopPropagation();sendPasswordResetEmail(user)"
              >
              <mat-icon>lock_reset</mat-icon>
            </button>
          }
          @if (isAdmin$ | async) {
            <button
              mat-button
              (click)="$event.stopPropagation();"
              [matMenuTriggerFor]="menu">
              <mat-icon>more_horiz</mat-icon>
            </button>
          }
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="sendPasswordResetEmail(user)"><mat-icon>lock_reset</mat-icon> {{ 'user_list.actions.password_reset' | translate }}</button>
            <button mat-menu-item (click)="sendVerificationEmail(user)"><mat-icon>email</mat-icon> {{ 'user_list.actions.verification_email' | translate }}</button>
            <button mat-menu-item (click)="blockUser(user)"><mat-icon>lock_person</mat-icon> {{ 'user_list.actions.block_user' | translate }}</button>
            <button mat-menu-item (click)="unblockUser(user)"><mat-icon>lock_open</mat-icon> {{ 'user_list.actions.unblock_user' | translate }}</button>
          </mat-menu>
        </td>
      </tr>
    }
    @if (usersList.length === 0) {
      <tr>
        <td [attr.colspan]="(fields$ | async).length">
          <div class="cell-wrapper">{{ 'user_list.no_results' | translate }}</div>
        </td>
      </tr>
    }
  </ng-container>
</app-sortable-list>
@if ((isAdmin$ | async) || (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)) {
  <doenkids-speed-dial
    class="speeddial-container"
    toggleIcon="add"
    [fabButtons]="floatingActionButtons$ | async"
    (fabClick)="speedDialClick($event)"
  ></doenkids-speed-dial>
}
</div>
</app-page-content>
